class Bank {
    id = null;
    name = '';
    address = '';
    city = '';
    post_code = '';
    swift_code = '';
    country_id = null;
    active = true;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Bank;
